import { Box, useTheme } from '@mui/material'
import type { MasterAgreement } from 'utils/agreementVersioning'
import VersionTimeline from './VersionTimeline'
import VersionedAgreementPanel from './VersionedAgreementPanel'

type AgreementVersionViewProps = {
  agreement: MasterAgreement
  selectedVersionIndex: number
  onVersionSelect: (index: number) => void
}

const AgreementVersionView = ({ agreement, selectedVersionIndex, onVersionSelect }: AgreementVersionViewProps) => {
  const theme = useTheme()
  const selectedVersion = agreement.versions[selectedVersionIndex]
  const previousVersion = selectedVersionIndex > 0 ? agreement.versions[selectedVersionIndex - 1] : undefined

  if (!selectedVersion) return null

  return (
    <Box
      sx={{
        display: 'flex',
        height: '100%',
        borderRadius: 2,
        overflow: 'hidden',
        border: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.paper',
      }}
    >
      <VersionTimeline
        versions={agreement.versions}
        selectedIndex={selectedVersionIndex}
        agreementFamily={agreement.agreementFamily}
        onSelect={onVersionSelect}
      />
      <VersionedAgreementPanel
        version={selectedVersion}
        previousVersion={previousVersion}
      />
    </Box>
  )
}

export default AgreementVersionView
